angular.module('rjmNg.controllers').controller('emailSummaryListCtrl', [
  "$scope"
  "EmailSummaries"
  "emailSummaryEnums"
  "app"
  "$clientAppUrl"
  (
    $scope
    EmailSummaries
    emailSummaryEnums
    app
    $clientAppUrl
  ) ->

    $scope.createEmailSummaryUrl = $clientAppUrl('/settings/emailsummary/create')

    $scope.getEditEmailSummaryUrl = (emailSummary) ->
      $clientAppUrl("/settings/emailsummary/#{emailSummary.id}/edit")

    $scope.getDuplicateEmailSummaryUrl = (emailSummary) ->
      $clientAppUrl("/settings/emailsummary/#{emailSummary.id}/duplicate")

    $scope.app = app
    $scope.emailSummaryEnums = emailSummaryEnums
    $scope.EmailSummaries = EmailSummaries

    # Wrapper for EmailSummariesService test, with some error handling.
    $scope.sendTest = (emailSummaryId, sendTo) ->
      EmailSummaries.sendTest(emailSummaryId, sendTo)
      .then (success) ->
        $scope.successText = "The email summary test is queued and will be sent shortly!"
      , (error) ->
        $scope.errorText = "There was an error sending your email summary test. Please try again later."

    # Wrapper for EmailSummariesService delete function, with some error handling.
    $scope.deleteEmailSummary = (emailSummaryId) ->
      EmailSummaries.delete(emailSummaryId)
      .then (successResponse) ->
          $scope.emailSummaryList = _($scope.emailSummaryList).reject (eSum) -> eSum.id is emailSummaryId
      , (errorResponse) ->
          $scope.errorText = "We could not delete the email summary at this time. Please try again later."

    $scope.frequencyName = (frequency) ->
      emailSummaryEnums.FREQUENCIES[frequency]

    $scope.hourName = (hour) ->
      emailSummaryEnums.HOURS[hour]

    # Wrapper for EamilSummaries
    _getEmailSummaries = () ->
      EmailSummaries.getCollection()
      .then (successResponse) ->
        $scope.emailSummaryList = successResponse
      , (errorResponse) ->
          $scope.errorText = "There was an error retrieving your email summaries."

    _getEmailSummaries()
  ]
)
